// @flow
import * as React from "react";
import { page } from "../../components/Auth/Page";

export const CapCreateProfilePage = page(
  React.lazy(() => import("./containers/CapCreateProfilePage")),
);
